import {on, emit, observe, eventSubscriber} from "./lib/EventDecorators";
import Level from "./Level";
import {levels} from "./StoryLevels";
import EventManager from "./lib/EventManager";
import * as Events from "./Events";

@eventSubscriber
class State {

  constructor(savedData?) {
    if (typeof savedData === 'object') {
      for (let prop in savedData) {
        if (Object.prototype.hasOwnProperty.call(savedData, prop)) {
          this[prop] = savedData[prop]
        }
      }
    }
  }

  currentLevel: Level
  @observe currentLevelIndex: number = 0

  @observe orientation: 'portrait' | 'landscape' = 'landscape'

  setLevel (level) {
    if (this.currentLevel) this.currentLevel.unsubscribe()
    this.currentLevel = new Level(level)
    EventManager.emit(Events.setLevel, this.currentLevel)
    EventManager.unlock([Events.move, Events.undo])
  }

  init () {
    this.setLevel(levels[this.currentLevelIndex])
  }

  @on(Events.nextLevel)
  // @on(Events.levelCompleted)
  nextLevel () {
    localStorage.setItem(levels[this.currentLevelIndex].name, 'completed')
    this.currentLevelIndex++
    localStorage.setItem('savedState', JSON.stringify({ currentLevelIndex: this.currentLevelIndex }))
    this.setLevel(levels[this.currentLevelIndex])
  }

  get showContinue () {
    return this.currentLevelIndex > 0
  }

  resetData () {
    localStorage.removeItem('savedState')
    this.currentLevelIndex = 0
    this.init()
  }
}

const state = new State(JSON.parse(localStorage.getItem('savedState')))

export default state
